import { useState } from 'react';
import { fetchConfigRequests, sendRfq, createConfigRequest, fetchConfigTotals } from 'api';
import { checkIfError } from 'utils/helpers';
import useAxios from 'hooks/useAxios';
import {
  IConfigurationRequestFetchRequest,
  IConfigurationRequestResource,
  IConfigurationRequestTotal,
  IRFQEmail,
} from '../../server/types';

export const useFetchConfigRequests = () => {
  const handleFetchConfigRequests = async (params?: IConfigurationRequestFetchRequest) => fetchConfigRequests(params);

  return [handleFetchConfigRequests] as const;
};

export const useSendRFQ = () => {
  const [request, { loading, error }] = useAxios<string>();
  const [message, setMessage] = useState<string>();

  const handleSendRFQEmail = async (data: IRFQEmail) => {
    const response = await request(sendRfq(data));

    if (checkIfError(response)) return response;

    setMessage(response);

    return response;
  };

  return [handleSendRFQEmail, { loading, error: error?.data?.message, data: message }] as const;
};

export const useCreateConfigRequest = () => {
  const [request, { loading, error }] = useAxios<IConfigurationRequestResource>();

  const handleCreateConfigRequest = async (data: IConfigurationRequestResource) => {
    const response = await request(createConfigRequest(data));

    if (checkIfError(response)) return response;

    return response;
  };

  return [handleCreateConfigRequest, { loading, error: error?.data?.message }] as const;
};

export const useFetchConfigTotals = () => {
  const [request, { loading, error }] = useAxios<IConfigurationRequestTotal[]>();

  const handleFetchConfigRequestTotals = async () => {
    const configs = await request(fetchConfigTotals());

    return configs;
  };

  return [handleFetchConfigRequestTotals, { loading, error: error?.data?.message }] as const;
};
